import { Configuration } from 'angular-api-gateway/v1/configuration';
import { Configuration as ConfigurationV2 } from 'angular-api-gateway/v2/configuration';
import { DomainsWithApiGatewayPrefix } from './const';

export const ApiGatewayConfig: (window: Window) => Configuration = (window: Window) => {
  if (DomainsWithApiGatewayPrefix.includes(window.location.host)) {
    return new Configuration({ withCredentials: true });
  }

  return new Configuration();
};

export const ApiGatewayConfigV2: (window: Window) => ConfigurationV2 = (window: Window) => {
  if (DomainsWithApiGatewayPrefix.includes(window.location.host)) {
    return new ConfigurationV2({ withCredentials: true });
  }

  return new ConfigurationV2();
};
